import { User } from '@arpeggi/shared'

export const profilePath = (user: Pick<User, 'walletAddress'>) => `/profile/${user.walletAddress}`
